import { watchActiveComponentRequest } from './activeComponent'
import { watchAutoStringingRequest } from './autoStringing'
import { watchCalculateSystem, watchSystemCalculationRequest } from './calculations/sagaWatchers'

import { watchDetectImagery } from './detectImagery'
import { watchNotifications } from './notifications'
import { watchProjectSectionClear } from './projectErrors'
import {
  watchCalculationCompleteForTariffRecommendations,
  watchCalculationStartForTariffRecommendations,
  watchTariffRecommendationRequest,
} from './tariffRecommendation'

export default [
  watchActiveComponentRequest,
  watchSystemCalculationRequest,
  watchCalculateSystem,
  watchAutoStringingRequest,
  watchDetectImagery,
  watchProjectSectionClear,
  watchNotifications,
  watchTariffRecommendationRequest,
  watchCalculationCompleteForTariffRecommendations,
  watchCalculationStartForTariffRecommendations,
]
